import React, { useState } from 'react';
import '../Recorrido/Recorrido.scss';
import { useTranslation } from 'react-i18next';

const tours = {
  vista1: 'https://kuula.co/share/hQl4z/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
  vista2: 'https://kuula.co/share/hQl4B/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
  vista3: 'https://kuula.co/share/hQl4r/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
  vista4: 'https://kuula.co/share/hQl74/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
  vista5: 'https://kuula.co/share/hsZc4/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
  vista6: 'https://kuula.co/share/hQl7N/collection/7Ddj3?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1',
};

const RecorridoHome = () => {
  const { t } = useTranslation();
  const [idScene, setIdScene] = useState('vista1');

  const handleTour = (tipo) => {
    const removeElement = document.getElementsByClassName('active');
    if (removeElement.length > 0) {
      removeElement[0].classList.remove('active');
    }
    const element = document.getElementById(tipo);
    if (element) {
      element.classList.add('active');
    }
    setIdScene(tipo);
  };

  return (
    <div className="contenedor_recorrido">
      <div className="recorrido_iframe_wrapper">
        <iframe
          key={idScene}
          className="ku-embed"
          src={tours[idScene]}
          frameBorder="0"
          allowFullScreen
          allow="xr-spatial-tracking; gyroscope; accelerometer"
          scrolling="no"
          title={`Recorrido ${idScene}`}
        />
      </div>

      <span className="disclamer">{t('recorridoHome.disclaimer')}</span>

      <div className="options">
        <button
          id="vista1"
          className="active"
          onClick={() => handleTour('vista1')}
        >
          Vista 1
        </button>
        <button id="vista2" onClick={() => handleTour('vista2')}>
          Vista 2
        </button>
        <button id="vista3" onClick={() => handleTour('vista3')}>
          Vista 3
        </button>
        <button id="vista4" onClick={() => handleTour('vista4')}>
          Vista 4
        </button>
        <button id="vista5" onClick={() => handleTour('vista5')}>
          Vista 5
        </button>
        <button id="vista6" onClick={() => handleTour('vista6')}>
          Vista 6
        </button>
      </div>
    </div>
  );
};

export default RecorridoHome;
